import { CommonConfirmDialog } from '../Common/CommonConfirmDialog';

type RemoveProductModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const RemoveProductModal = ({
  isOpen,
  onClose,
  onConfirm,
}: RemoveProductModalProps) => {
  return (
    <CommonConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      icon="fa-light fa-trash-can"
      title="Remove property?"
      content="Are you sure you want to remove this property?"
      confirmButtonText="Remove"
      onConfirm={onConfirm}
    />
  );
};
